/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {StartStorefrontLoginRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {StartStorefrontLoginResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const startStorefrontLogin = (request: StartStorefrontLoginRequest, options?: CashRequestOptions) => post<StartStorefrontLoginRequest, StartStorefrontLoginResponse>("/2.0/cash/start-storefront-login", request, {...options, rejectOnError: true })